import { mutatorAction } from 'satcheljs';
import type { ProactiveDraftsState } from '../store/schema/ProactiveDraftsState';
import { getProactiveDraftsStore } from '../store/store';
import { ProactiveDraftsLoadingState } from '../store/schema/ProactiveDraftsLoadingState';

const createProactiveDraftsStateForKeyMutator: (itemId: string | undefined) => void = mutatorAction(
    'createProactiveDraftsStateForKeyMutator',
    function createProactiveDraftsStateForKey(itemId: string | undefined): void {
        if (!itemId) {
            return;
        }

        // Ensure that the proactive drafts state is created for the given key
        const proactiveDraftsStore = getProactiveDraftsStore();
        if (!proactiveDraftsStore.proactiveDraftsListMap.has(itemId)) {
            const attachmeLabelsViewState: ProactiveDraftsState = {
                proactiveDraftsList: [],
                loadingState: ProactiveDraftsLoadingState.NotLoaded,
                itemId,
                selectedDraftId: null,
                itemTelemetrySession: undefined,
                proactiveDraftsAddedOnEditorList: [],
                // by default, proactive drafts bar is visible and expanded
                proactiveDraftsBarVisible: true,
                proactiveDraftsBarExpanded: true,
            };
            getProactiveDraftsStore().proactiveDraftsListMap.set(itemId, attachmeLabelsViewState);
        }
    }
);
export default createProactiveDraftsStateForKeyMutator;
